import React from 'react';
import PropTypes from 'prop-types';
import { VStack, Text, Flex, Container, Box, useTheme } from '@chakra-ui/react';

import { generateSectionId } from '@rsc/ui-components/dept/utils/generateSectionId';
import CTAButton from '@rsc/ui-components/tailwind/CTAButton';
import Image from '@rsc/ui-components/tailwind/Image';

export default function EditorialContentVideo({ block }) {
  const { headline, copy, editorialMedia, iconsWithCopy } = block;
  const theme = useTheme();

  return (
    <Box
      {...generateSectionId(block)}
      py={24}
      pt={{ base: 14, lg: 24 }}
      my={16}
      bg="brand.ink"
      bgImage={theme.images.sectionPattern}
      bgRepeat="repeat-x"
      bgPosition="left bottom"
    >
      <Container as={Flex} color="typography.lighter" pb={12}>
        <VStack gap={{ base: 14, lg: 16 }} align="start" alignSelf="center">
          <VStack align="start">
            <Text as="h2" textStyle="h1" mb={2} color="white">
              {headline}
            </Text>
            <Text textStyle="bodyLarge">{copy}</Text>
          </VStack>
          <Image
            className="max-h-80 w-full rounded-lg lg:hidden"
            ratio={null}
            sanityImage={editorialMedia?.image}
            srcSetBasisWidth={900}
          />
          <Flex display={{ base: 'contents', lg: 'flex' }} gap={8}>
            {iconsWithCopy?.map(({ icon, copy: iconCopy, _key, cta }) => (
              <VStack key={_key} align="start" mr={8} gap={0}>
                <Image
                  className="h-[3.5rem] mb-4 w-fit [&>img]:object-contain"
                  ratio={null}
                  sanityImage={icon}
                  srcSetBasisWidth={200}
                />
                <Text mb={6}>{iconCopy}</Text>
                <CTAButton cta={cta} />
              </VStack>
            ))}
          </Flex>
        </VStack>
        <Image
          className="hidden w-[20.9rem] h-[37.2rem] rounded-lg lg:flex lg:ml-12 lg:min-w-72 xl:ml-24 xl:min-w-[20.9rem]"
          ratio={null}
          sanityImage={editorialMedia?.image}
        />
      </Container>
    </Box>
  );
}

EditorialContentVideo.propTypes = {
  block: PropTypes.shape({
    _type: PropTypes.string,
    headline: PropTypes.string,
    copy: PropTypes.string,
    cta: PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.shape({
        linkType: PropTypes.string,
        href: PropTypes.string,
        internalLink: PropTypes.shape({
          slug: PropTypes.string,
        }),
      }),
    }),
    editorialMedia: PropTypes.shape({
      image: PropTypes.shape({
        asset: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    iconsWithCopy: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.shape({
          asset: PropTypes.shape({
            url: PropTypes.string,
          }),
        }),
        copy: PropTypes.string,
      })
    ),
  }).isRequired,
};
